import TwoFactorSettings from "./TwoFactorSettings";
import LoginPage from "../../pages/Login/LoginPage";
import "./Enforce2FAGate.css";

// Full-screen blocking gate shown after login when the organization enforces
// Two-Step Verification and this user hasn't set it up yet. There is no "skip" —
// the only ways out are: enable 2FA (→ onEnabled) or sign out.
//
// The login page sits behind, blurred and inert (a frosted-glass backdrop rather
// than a flat colour); the setup card stays sharp on top.
export default function Enforce2FAGate({ user, onEnabled, onLogout }) {
  return (
    <div className="enforce2fa-gate">
      <div className="enforce2fa-backdrop" aria-hidden="true">
        <LoginPage />
      </div>
      <div className="enforce2fa-scrim" aria-hidden="true" />

      <div className="enforce2fa-inner">
        <div className="enforce2fa-head">
          <div className="enforce2fa-emoji">🔐</div>
          <h1 className="enforce2fa-title">Two-Step Verification Required</h1>
          <p className="enforce2fa-sub">
            Your organization now requires <b>2FA</b> for all accounts.
            {user?.name ? <> Hi <b>{user.name}</b>, please</> : <> Please</>} set it up with an
            authenticator app to continue — you won't be able to open your dashboard until it's on.
          </p>
        </div>

        <div className="enforce2fa-card">
          <TwoFactorSettings onEnabled={onEnabled} />
        </div>

        <div className="enforce2fa-footer">
          <button type="button" className="enforce2fa-signout" onClick={onLogout}>
            Sign out instead
          </button>
        </div>
      </div>
    </div>
  );
}
